<div class="container-fluid">
  <div class="header-container">
    <div class="row   justify-content-start mb-2">
      <div class="col-12">
      <span class="iso-header ml-2">
{{ 'bikeshop.shop_setup.card_headers.in_app_payments' | translate }}
</span>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="sub-header margin-top-16">
      {{"bikeshop.shop_profile.in_app_payments.configuration_header" | translate}}
    </div>
    <div *ngIf="allowStripe">
      <app-connect-stripe [partner]="partner"></app-connect-stripe>
    </div>
    <div *ngIf="allowPeachPayments">
      <app-setup-peach-payments [partner]="partner"></app-setup-peach-payments>
    </div>
    <div *ngIf="!allowStripe && !allowPeachPayments">
      <div class="warn margin-top-16">
        {{"bikeshop.shop_profile.in_app_payments.no_payments_for_country" | translate}}
      </div>
    </div>
  </div>
</div>
